import css from 'styled-jsx/css';

const styles = css.global`#partiu-gp-calendario {
  padding: 56px 0;
  background: #fff;
  overflow: hidden;
}

#partiu-gp-calendario .calendario-eyebrow {
  margin: 0 0 4px;
  color: #222;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 400;
  text-align: center;
}

#partiu-gp-calendario .calendario-titulo {
  margin: 0 0 24px;
  color: #222;
  font-family: 'SantanderHeadline';
  font-size: 28px;
  font-weight: 800;
  line-height: 32px;
  text-align: center;
}

#partiu-gp-calendario .slide {
  background: #f6f6f6;
  border-radius: 24px;
  padding: 24px;
  width: 212px;
  flex: 0 0 212px;
  min-height: 252px;
  margin-right: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#partiu-gp-calendario .slide-numero {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ec0000;
  color: #fff;
  font-family: 'SantanderMicroText';
  font-size: 24px;
  font-weight: 700;
  margin: 0 auto 16px;
  flex-shrink: 0;
}

#partiu-gp-calendario .slide-titulo {
  margin: 0 0 8px;
  color: #222;
  font-family: 'SantanderMicroText';
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
}

#partiu-gp-calendario .slide-texto {
  margin: 0 0 16px;
  color: #444;
  font-family: 'SantanderMicroText';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
}

#partiu-gp-calendario .slide-data {
  display: block;
  margin: auto auto 0;
  max-width: 100%;
  width: fit-content;
  box-sizing: border-box;
  border: 1px solid #ec0000;
  border-radius: 999px;
  padding: 4px 16px;
  color: #ec0000;
  font-family: 'SantanderMicroText';
  font-size: 14px;
  line-height: 16px;
  font-weight: 700;
  text-align: center;
  white-space: normal;
}

#partiu-gp-calendario .pagination-container {
  margin: auto;
}

#partiu-gp-calendario .pagination-container .bullet {
  background-color: #ccc;
}

#partiu-gp-calendario .pagination-container .bullet.active,
#partiu-gp-calendario .pagination-container .bullet[selected] {
  background-color: #ec0000;
}

#partiu-gp-calendario .home-pagination {
  margin-top: 24px;
  max-width: 304px;
}

@media (min-width: 992px) {
  #partiu-gp-calendario .calendario-eyebrow {
    font-family: 'SantanderHeadline';
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 16px;
  }

  #partiu-gp-calendario .calendario-titulo {
    margin: 0 0 44px;
    font-size: 54px;
    line-height: 62px;
  }

  #partiu-gp-calendario .calendario-cards {
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 24px;
  }

  #partiu-gp-calendario .calendario-cards .slide {
    flex: 0 0 212px;
    width: 212px;
    margin-right: 0;
  }
}
`;

export default styles;